import React, { useEffect, useRef, useState } from "react";
import { Button, Header } from "../components";
import {
  FiDelete,
  FiDownload,
  FiServer,
  FiSettings,
  FiUpload,
} from "react-icons/fi";
import { BsCircleFill, BsCpu, BsCpuFill } from "react-icons/bs";
import {
  BiDollar,
  BiLink,
  BiLira,
  BiPause,
  BiPlay,
  BiPlayCircle,
  BiRecycle,
  BiStop,
  BiTrash,
  BiUnlink,
  BiWorld,
} from "react-icons/bi";
import { GrAdd, GrAttachment } from "react-icons/gr";
import { GiAttachedShield, GiPingPongBat } from "react-icons/gi";
import { useStatContext } from "../contexts/ContextProvider";
import Modal from "../components/Modal";
import {
  fetchServersList,
  changeServerStatus,
  changeServerAccess,
  toggleServerServiceStatus,
  uploadServerServiceProfile,
  deleteServerService,
  fetchTelemetryServersList,
  attachServer,
  deleteServer,
  resetCore,
  addRule,
  changeRule,
  deleteRule,
  fetchRulesList,
  toggleRuleStatus,
  getServersWithoutRules,
} from "../utils/HttpUtils";
import { SiStatuspage } from "react-icons/si";
import { RiServiceLine } from "react-icons/ri";
import UploadButton from "../components/UploadButton";
import { MdDelete, MdDeleteForever } from "react-icons/md";

const Rules = () => {
  const [servers, setServers] = useState([]);
  const [rules, setRules] = useState([]);
  let notRuledServers = [];

  const addRuleServerNameInputRef = useRef(null);
  const addRuleInputRef = useRef(null);

  if (servers.length !== 0) {
    notRuledServers = servers.filter(
      (tserver) =>
        !rules.find(
          (r) => r.serverName.toUpperCase() === tserver.serverName.toUpperCase()
        )
    );
  }

  const { setCurrentToast } = useStatContext();
  const [addRuleModal, setAddRuleModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDesc, setModalDesc] = useState("");
  const [modalIcon, setModalIcon] = useState(<BiTrash />);
  const [questionableAction, setQuestionableAction] = useState(
    () => async () => {}
  );

  const fetchServers = async () => {
    try {
      const resp = await fetchServersList();
      setServers(resp);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRules = async () => {
    try {
      const resp = await fetchRulesList();
      const filteredRules = resp.filter((rule) =>
        rule.serverRule.includes("IPRANGE_BAN")
      );
      setRules(filteredRules);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // loading
    // fetch rules
    fetchRules();
    // fetch servers
    fetchServers();
    // end loading
    return () => {};
  }, []);

  return (
    <div
      className="relative m-10 p-5
      dark:bg-secondary-dark-bg
      font-network"
    >
      <div className="absolute border-t-1 border-l-1 border-white h-1 w-1 left-3 top-3"></div>
      <div className="absolute border-t-1 border-r-1 border-white h-1 w-1 right-3 top-3"></div>
      <div className="absolute border-b-1 border-l-1 border-white h-1 w-1 left-3 bottom-3"></div>
      <div className="absolute border-b-1 border-r-1 border-white h-1 w-1 right-3 bottom-3"></div>
      <Header category="Services" title="Rules" />
      <div className="w-full">
        <div className="flex border-b-1 gap-5 pb-4 ml-2">
          <button
            onClick={() => {
              setAddRuleModal(true);
            }}
            className="cybr-btn"
            style={{ "--primary-hue": 160 }}
          >
            Add rule
            <span aria-hidden className="cybr-btn__glitch">
              Add rule
            </span>
          </button>
          <button
            onClick={() => {
              setQuestionableAction(() => async () => {
                return resetCore();
              });
              setModalIcon(
                <FiSettings className="mx-auto text-[#1ffea9] text-3xl" />
              );
              setModalDesc("Are you sure you want to reload the core?");
              setModalOpen(true);
            }}
            className="cybr-btn"
            style={{ "--primary-hue": 10 }}
          >
            Reload core
            <span aria-hidden className="cybr-btn__glitch">
              Reload core
            </span>
          </button>
        </div>
        <div className="flex justify-start items-start flex-wrap gap-4 mt-2">
          {rules.map((rule, index) => {
            const statusText = rule.serverRuleStatus ? "Active" : "Disabled";
            const statusBgColor = rule.serverRuleStatus
              ? "[#1ffea9]"
              : "red-500";

            const ruleItems = rule.serverRule.split("=");
            const ruleType = ruleItems[0];
            const ruleValue = ruleItems[1];

            return (
              <div
                key={rule.ruleId}
                className="relative flex flex-col
                 w-[22rem] m-1 p-5
                 border-[#1ffea9] border-1
                 hover:bg-radial-gradient"
              >
                <div className="absolute border-t-1 border-l-1 border-white h-1 w-1 left-3 top-3"></div>
                <div className="absolute border-t-1 border-r-1 border-white h-1 w-1 right-3 top-3"></div>
                <div className="absolute border-b-1 border-l-1 border-white h-1 w-1 left-3 bottom-3"></div>
                <div className="absolute border-b-1 border-r-1 border-white h-1 w-1 right-3 bottom-3"></div>
                <div className="flex items-center pb-1 border-b-1 border-gray-400">
                  <BiLink className="text-[#1ffea9]" />
                  <p className="ms-2 text-sm text-white font-bold">
                    {rule.serverName}
                  </p>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <p className="flex items-center text-sm gap-1">
                    <span className="font-semibold text-[#1ffea9]">
                      Status:
                    </span>
                  </p>

                  <p
                    className={`ms-2 bg-${statusBgColor}
                text-black text-sm px-2 py-1
                font-semibold`}
                  >
                    {statusText}
                  </p>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <p className="flex items-center text-sm gap-1">
                    <span className="font-semibold text-[#1ffea9]">
                      {ruleType}:
                    </span>
                  </p>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <p className="flex items-center text-sm gap-1">
                    <span className="text-white">{ruleValue}</span>
                  </p>
                </div>

                <div className="flex items-center gap-1 mt-2">
                  <button
                    type="button"
                    onClick={() => {
                      setQuestionableAction(() => async () => {
                        return toggleRuleStatus(
                          rule.ruleId,
                          !rule.serverRuleStatus
                        );
                      });
                      setModalIcon(
                        <BiPlayCircle className="mx-auto text-green-500 text-3xl" />
                      );
                      setModalDesc("Are you sure you want change rule status?");
                      setModalOpen(true);
                    }}
                    className={`border-1 ${
                      rule.serverRuleStatus
                        ? "border-yellow-500 hover:bg-yellow-500 text-yellow-500"
                        : "border-[#1ffea9] hover:bg-[#1ffea9] text-[#1ffea9]"
                    }                
                                       hover:text-black
                                       p-2 m-1`}
                  >
                    {rule.serverRuleStatus ? <BiPause /> : <BiPlay />}
                  </button>
                  <button
                    type="button"
                    className="border-1 border-red-500
                   hover:bg-red-500
                   text-red-500
                   hover:text-black 
                   p-2 m-1"
                    onClick={() => {
                      setQuestionableAction(() => async () => {
                        return deleteRule(rule.ruleId);
                      });
                      setModalIcon(
                        <MdDeleteForever className="mx-auto text-red-500 text-3xl" />
                      );
                      setModalDesc(
                        "Are you sure you want to delete this rule?"
                      );
                      setModalOpen(true);
                    }}
                  >
                    <MdDelete />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <div className="text-center w-56">
          {modalIcon}
          <div className="mx-auto my-4 w-48">
            <h3 className="text-lg font-black text-[#1ffea9]">Confirm</h3>
            <p className="text-sm text-white">{modalDesc}</p>
          </div>
          <div className="flex gap-4">
            <button
              className="bg-[#1ffea9] py-1 text-black w-full"
              onClick={async () => {
                try {
                  const result = await questionableAction();
                  fetchServers();
                  fetchRules();
                  setCurrentToast({
                    isToasted: true,
                    text: result,
                    color: "[#1ffea9]",
                  });
                } catch (error) {
                  setCurrentToast({
                    isToasted: true,
                    text: error.message,
                    color: "red-500",
                  });
                }

                setModalOpen(false);
              }}
            >
              Yes
            </button>
            <button
              className="bg-red-500 py-1 text-black btn btn-light w-full"
              onClick={() => setModalOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        open={addRuleModal}
        onClose={() => {
          addRuleServerNameInputRef.current.value = "";
          addRuleInputRef.current.value = "";
          setAddRuleModal(false);
        }}
      >
        <div className="text-center">
          <GrAttachment className="mx-auto" />
          <div className="my-4">
            <h3 className="text-lg font-black my-5 text-[#1ffea9]">Add Rule</h3>
            <select ref={addRuleServerNameInputRef} className="border-1">
              {notRuledServers.map((nServer) => (
                <option key={nServer.serverId} value={nServer.serverName}>
                  {nServer.serverName}
                </option>
              ))}
            </select>
          </div>
          <div className="flex justify-between my-2 ">
            <label className="text-white">Rule:</label>
            <input ref={addRuleInputRef} className="border-1 ml-2" />
          </div>
          <div className="flex gap-4 mt-4">
            <button
              className="bg-[#1ffea9] py-1 text-black w-full"
              onClick={async () => {
                try {
                  const serverName = addRuleServerNameInputRef.current.value;
                  const rule = addRuleInputRef.current.value;

                  const result = await addRule(serverName, rule);
                  fetchServers();
                  fetchRules();
                  setCurrentToast({
                    isToasted: true,
                    text: result,
                    color: "[#1ffea9]",
                  });
                } catch (error) {
                  setCurrentToast({
                    isToasted: true,
                    text: error.message,
                    color: "red-500",
                  });
                }

                addRuleServerNameInputRef.current.value = "";
                addRuleInputRef.current.value = "";

                fetchServers();
                setAddRuleModal(false);
              }}
            >
              Add
            </button>
            <button
              className="bg-red-500 py-1 text-black w-full"
              onClick={() => {
                addRuleServerNameInputRef.current.value = "";
                addRuleInputRef.current.value = "";
                setAddRuleModal(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Rules;
